export { isPendingPix } from '@src/domains/transactions';
